import React from "react";
import "./taskSkeleton.scss";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
import { URButtonSkeleton } from "./skeletonWidgets/buttonSkeleton";
function URTaskSkeleton(props: any) {
  return (
    <>
      <div className="taskSkeleton">
        <div className="btnSec">
          <URLineSkeleton className='line lineThick size30'/>
          <URButtonSkeleton className='skeletonBtn' />
        </div>
        <div className="taskBox">
          <div className="boxFirstLine">
            <URLineSkeleton className='line lineThick size60'/>
            <URButtonSkeleton className='skeletonBtn sizelg' />
            
          </div>
          <div className="boxSecondLine">
            <URLineSkeleton className='line lineThick size55'/>
            <URLineSkeleton className='line lineThick size5'/>
            <URLineSkeleton className='line lineThick size25'/>
          </div>
        </div>
      </div>
    </>

  );
}

export {
  URTaskSkeleton
};